import { v4 as uuidv4 } from 'uuid';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import useSnackbarStore from './use-snackbar';
const { makeRequest } = require('api/api-client');
const { default: useLoadingStore } = require('./use-loading');
const { API_ENDPOINTS } = require('api/endpoints');
const { HTTP } = require('constants/http-method');
const { setSnackbar } = useSnackbarStore.getState();

const useOnboardingStore = create(
  persist(
    (set, get) => ({
      walkTroughId: null,
      positionId: null,
      documentStep: [],
      walkThroughName: '',
      walkThroughAbbreviation: '',
      onboardingTypes: [],
      selectedSteps: [],
      adminMembers: [],
      organizationMembers: [],
      stepId: null,
      onboardingStepStored: [],
      allBoardings: [],

      activeStep: {},
      setActiveStep: (activeStep) =>
        set({
          activeStep: activeStep,
        }),

      pagination: {
        pageSize: 10,
        totalItems: 0,
        totalPages: 0,
        currentPage: 1,
      },
      onboardingLoading: false,
      onboardingStepLoading: false,
      createOnboardingLoading: false,

      // Add a resetPagination action
      resetPagination: () =>
        set({
          pagination: {
            pageSize: 10,
            totalItems: 0,
            totalPages: 0,
            currentPage: 1,
          },
        }),

      setSelectedSteps: (steps) =>
        set((state) => ({
          selectedSteps:
            typeof steps === 'function' ? steps(state.selectedSteps) : steps,
        })),

      setOnboardingStepStored: (steps) =>
        set((state) => ({
          onboardingStepStored:
            // typeof steps === 'function'
            //   ? steps(state.onboardingStepStored)
            //   :
            steps,
        })),

      addStep: (step) =>
        set((state) => {
          return {
            selectedSteps: [
              ...state.selectedSteps,
              { ...step, uniqueId: uuidv4() },
            ],
          };
        }),

      removeStep: (index) =>
        set((state) => ({
          selectedSteps: state.selectedSteps.filter((_, i) => i !== index),
        })),

      clearSteps: () =>
        set({
          selectedSteps: [],
          onboardingStepStored: [],
          walkTroughId: null,
          positionId: null,
          walkThroughAbbreviation: '',
          walkThroughName: '',
          stepId: null,
          activeStep: {},
        }),

      getOnboardingSteps: async () => {
        useLoadingStore.getState().setLoading(true);
        try {
          const { data: response } = await makeRequest(
            HTTP.GET,
            API_ENDPOINTS.GET_ONBOARDING_TYPES
          );

          if (response.success) {
            set({ onboardingTypes: response?.data?.data });
          }
        } catch (error) {
        } finally {
          useLoadingStore.getState().setLoading(false);
        }
      },

      // duplicate onboarding
      duplicateOnboarding: async ({ id }) => {
        useLoadingStore.getState().setLoading(true);
        try {
          const { data: response } = await makeRequest(
            HTTP.POST,
            API_ENDPOINTS.DUPLICATE_ONBOARDING,
            null,
            null,
            id
          );
          if (response.success) {
            setSnackbar(
              response.message || 'Onboarding duplicated successfully'
            );
            get().getAllOnboarding({});
            // successCallback && successCallback(response);
            // set({ walkTroughId: response?.data?.data?.id });
            // set({ walkThroughName: response?.data?.data?.name });
            // set({ positionId: response?.data?.data?.positionId });
          }
        } catch (error) {
          console.error('Error duplicating onboarding:', error);
        } finally {
          useLoadingStore.getState().setLoading(false);
        }
      },

      // first step of create new onboarding
      createOnboarding: async ({ data, successCallback, errorCallback }) => {
        useLoadingStore.getState().setLoading(true);
        set({ createOnboardingLoading: true });
        try {
          // get().clearSteps();

          const { data: response } = await makeRequest(
            HTTP.POST,
            API_ENDPOINTS.CREATE_ONBOARDING,
            data
          );

          if (response.success) {
            set({ positionId: response?.data?.data?.positionId });
            get().clearSteps();
            successCallback && successCallback(response);
            set({ walkTroughId: response?.data?.data?.id });
            set({
              walkThroughAbbreviation:
                response?.data?.data?.position?.abbreviation,
            });
          } else {
            // Instead of throwing a new Error, pass the entire response

            throw response;
          }
        } catch (error) {
          console.error('Error creating onboarding:', error);
          errorCallback && errorCallback(error);
        } finally {
          set({ createOnboardingLoading: false });
          useLoadingStore.getState().setLoading(false);
        }
      },

      updateOnboarding: async ({ id, data, successCallback }) => {
        useLoadingStore.getState().setLoading(true);
        set({ createOnboardingLoading: true });
        try {
          const { data: response } = await makeRequest(
            HTTP.PUT,
            API_ENDPOINTS.UPDATE_ONBOARDING,
            data,
            null,
            id
          );
          if (response.success) {
            set({ walkTroughId: response?.data?.data?.id });
            set({
              walkThroughAbbreviation:
                response?.data?.data?.position?.abbreviation,
            });
            set({ positionId: response?.data?.data?.positionId });

            successCallback && successCallback(response);
            // await get().getAllOnboarding({});
          }
        } catch (error) {
        } finally {
          set({ createOnboardingLoading: false });
        }
      },

      viewOnboarding: async ({ stepId, successCallback }) => {
        useLoadingStore.getState().setLoading(true);
        try {
          const { data: response } = await makeRequest(
            HTTP.GET,
            API_ENDPOINTS.VIEW_ONBOARDING,
            null,
            null,
            stepId
          );

          if (response.success) {
            set({
              walkTroughId: response?.data?.data?.id,
              walkThroughName: response?.data?.data?.name,
              walkThroughAbbreviation:
                response?.data?.data?.position?.abbreviation,
              positionId: response?.data?.data?.position?.id,
              onboardingStepStored: response?.data?.data?.steps || [],
            });
            successCallback && successCallback(response);
          }
        } catch (error) {
          console.error('Error viewing onboarding:', error);
        } finally {
          useLoadingStore.getState().setLoading(false);
        }
      },

      getAllOnboarding: async ({
        query = null,
        successCallback = () => {},
      }) => {
        set({ onboardingLoading: true });
        useLoadingStore.getState().setLoading(true);
        try {
          const { data: response } = await makeRequest(
            HTTP.GET,
            API_ENDPOINTS.GET_ALL_ONBOARDING,
            null,
            query
          );

          if (response.success) {
            set((state) => ({
              allBoardings: response?.data,
              pagination: {
                ...state.pagination,
                pageSize: response.data?.pagination?.limit,
                totalItems: response.data?.pagination?.total,
                currentPage: response.data?.pagination?.page,
                totalPages: response.data?.pagination?.totalPages,
              },
            }));
            successCallback && successCallback();
          }
        } catch (error) {
        } finally {
          set({ onboardingLoading: false });
          useLoadingStore.getState().setLoading(false);
        }
      },

      // api that are creating every onboarding steps
      createOnboardingSteps: async ({ data, successCallback }) => {
        useLoadingStore.getState().setLoading(true);
        set({ onboardingStepLoading: true });
        try {
          const { data: response } = await makeRequest(
            HTTP.POST,
            API_ENDPOINTS.POST_ONBOARDING_STEPS,
            data
          );

          if (response.success) {
            const returnedStepId = response?.data?.data?.id;

            set((state) => {
              const existingIndex =
                // state.onboardingStepStored &&
                // Array.isArray(state.onboardingStepStored) &&
                state.onboardingStepStored?.findIndex(
                  (step) =>
                    (data?.stepId ? step?.order : step?.stepId) === data.order
                );

              const existingStep = state.selectedSteps?.find(
                (step) => step?.uniqueId === data?.order
              );
              const existingStepId = existingStep?.stepId;

              const updatedSelectedSteps = state.selectedSteps.map((step) => {
                if (step?.uniqueId === data?.order) {
                  return {
                    ...step,
                    stepId: existingStepId ?? returnedStepId,
                  };
                }
                return step;
              });

              const updatedOnboardingStepStored =
                // state.onboardingStepStored &&
                // Array.isArray(state.onboardingStepStored) &&
                state.onboardingStepStored?.map((step) => {
                  if (step?.uniqueId === data?.order) {
                    return {
                      ...step,
                      stepId: existingStepId ?? returnedStepId,
                    };
                  }
                  return step;
                });
              set({ selectedSteps: updatedSelectedSteps });
              set({ onboardingStepStored: updatedOnboardingStepStored });

              const stepIdToUse = data.stepId ?? returnedStepId;

              const updatedStepData = {
                ...data,
                stepId: stepIdToUse,
                content: data?.content?.text || data?.content,
                video_url: data?.content?.videoUrl || data?.videoUrl,
                url: data?.content?.url || data?.url,
                buttonLabel: data?.content?.buttonLabel || data?.buttonLabel,
              };

              if (existingIndex >= 0) {
                const updatedSteps = [...state.onboardingStepStored];
                // const updatedSteps = Array.isArray(state.onboardingStepStored)
                //   ? [...state.onboardingStepStored]
                //   : [];
                updatedSteps[existingIndex] = {
                  ...updatedSteps[existingIndex],
                  ...updatedStepData,
                };

                return {
                  stepId: stepIdToUse,
                  onboardingStepStored: updatedSteps,
                };
              } else {
                return {
                  stepId: stepIdToUse,
                  onboardingStepStored: [
                    ...state.onboardingStepStored,
                    updatedStepData,
                  ],
                };
              }
            });
            successCallback && successCallback(response);
            // await get().getAllOnboarding({});
          }
        } catch (error) {
          console.error('Error creating onboarding steps:', error);
        } finally {
          set({ onboardingStepLoading: false });
          useLoadingStore.getState().setLoading(false);
        }
      },

      // update single step of onboarding
      updateSingleOnboardingSteps: async ({
        stepId,
        data,
        successCallback,
      }) => {
        set({ onboardingStepLoading: true });
        useLoadingStore.getState().setLoading(true);
        try {
          const { data: response } = await makeRequest(
            HTTP.PUT,
            API_ENDPOINTS.SINGLE_STEP_UPDATE,
            data,
            null,
            stepId
          );

          if (response.success) {
            const returnedStepId = response?.data?.data?.id;

            set((state) => {
              const existingIndex =
                state.onboardingStepStored &&
                state.onboardingStepStored?.length > 0 &&
                state.onboardingStepStored?.findIndex(
                  (step) =>
                    (data?.stepId ? step?.order : step?.stepId) === data.order
                  // (step) => step?.uniqueId === data.order
                  // (step) => step.order === data.order
                );

              const existingStep = state.selectedSteps?.find(
                (step) => step?.uniqueId === data?.order
              );
              const existingStepId = existingStep?.stepId;
              //appeand into selectedSteps
              const updatedSelectedSteps = state.selectedSteps.map((step) => {
                if (step?.uniqueId === data?.order) {
                  return {
                    ...step,
                    stepId: existingStepId ?? returnedStepId,
                  };
                }
                return step;
              });
              set({ selectedSteps: updatedSelectedSteps });

              const stepIdToUse = data.stepId ?? returnedStepId;

              const updatedStepData = {
                ...data,
                stepId: stepIdToUse,
                content: data?.content?.text || data?.content,
                video_url: data?.content?.videoUrl || data?.videoUrl,
                url: data?.content?.url || data?.url,
                buttonLabel: data?.content?.buttonLabel || data?.buttonLabel,
              };
              if (existingIndex >= 0) {
                const updatedSteps = [...state.onboardingStepStored];
                updatedSteps[existingIndex] = {
                  ...updatedSteps[existingIndex],
                  ...updatedStepData,
                };
                return {
                  stepId: stepIdToUse,
                  onboardingStepStored: updatedSteps,
                };
              } else {
                return {
                  stepId: stepIdToUse,
                  onboardingStepStored: [
                    ...state.onboardingStepStored,
                    updatedStepData,
                  ],
                };
              }
            });
            successCallback && successCallback(response);
            // await get().getAllOnboarding({});
          }
        } catch (error) {
          console.error('Error creating onboarding steps:', error);
        } finally {
          set({ onboardingStepLoading: false });
          useLoadingStore.getState().setLoading(false);
        }
      },

      deleteOnboardingStep: (orderId) =>
        set((state) => ({
          onboardingStepStored: state.onboardingStepStored?.filter(
            (step) => step.uniqueId !== orderId
          ),
        })),

      deleteStepStored: (orderId) =>
        set((state) => ({
          onboardingStepStored: state.selectedSteps.filter(
            (step) => step.order !== orderId
          ),
        })),

      singleOnboardingStepDelete: async (orderId) => {
        useLoadingStore.getState().setLoading(true);
        set({ onboardingLoading: true });

        try {
          const { data: response } = await makeRequest(
            HTTP.DELETE,
            API_ENDPOINTS.SINGLE_STEP_DELETE,
            null,
            null,
            orderId
          );

          if (response.success) {
            set((state) => ({
              selectedSteps: state.selectedSteps.filter(
                (step) => step?.stepId !== orderId
              ),
              onboardingStepStored: state.onboardingStepStored?.filter(
                (step) => step?.stepId !== orderId
                // || step.order !== orderId
              ),
            }));
            // await get().getAllOnboarding({});
            // get().clearSteps();
          }
        } catch (error) {
          console.error('Error deleting onboarding step:', error);
        } finally {
          set({ onboardingLoading: false });
          useLoadingStore.getState().setLoading(false);
        }
      },

      getAdminMember: async (successCallback) => {
        useLoadingStore.getState().setLoading(true);
        try {
          const { data: response } = await makeRequest(
            HTTP.GET,
            API_ENDPOINTS.GET_ADMIN_MEMBERS
          );

          if (response.success) {
            set({ adminMembers: response?.data?.data });
            successCallback && successCallback(response);
          }
        } catch (error) {
        } finally {
          useLoadingStore.getState().setLoading(false);
        }
      },

      getOrganizationMember: async (successCallback) => {
        useLoadingStore.getState().setLoading(true);
        try {
          const { data: response } = await makeRequest(
            HTTP.GET,
            API_ENDPOINTS.GET_ORGANIZATION_MEMBERS
          );

          if (response.success) {
            set({ organizationMembers: response?.data?.data });
            successCallback && successCallback(response);
          }
        } catch (error) {
        } finally {
          useLoadingStore.getState().setLoading(false);
        }
      },

      getDocumentStep: async (successCallback) => {
        useLoadingStore.getState().setLoading(true);
        const { positionId } = get();

        try {
          const { data: response } = await makeRequest(
            HTTP.GET,
            API_ENDPOINTS.GET_DOCUMENT_STEP,
            null,
            null,
            positionId
          );
          if (response.success) {
            set({ documentStep: response?.data?.data });
            successCallback && successCallback(response);
          }
        } catch (error) {
        } finally {
          useLoadingStore.getState().setLoading(false);
        }
      },

      getReferenceRequirements: async (successCallback) => {
        useLoadingStore.getState().setLoading(true);
        const { positionId } = get();

        try {
          const { data: response } = await makeRequest(
            HTTP.GET,
            API_ENDPOINTS.GET_REFERENCEFORM_REQUIREMENTS,
            null,
            null,
            positionId
          );
          if (response.success) {
            set({ documentStep: response?.data?.data });
            successCallback && successCallback(response);
          }
        } catch (error) {
        } finally {
          useLoadingStore.getState().setLoading(false);
        }
      },

      getCompetencyTestRequirements: async (successCallback) => {
        useLoadingStore.getState().setLoading(true);
        const { positionId } = get();

        try {
          const { data: response } = await makeRequest(
            HTTP.GET,
            API_ENDPOINTS.GET_COMPETENCY_TEST_REQUIREMENTS,
            null,
            null,
            positionId
          );
          if (response.success) {
            set({ documentStep: response?.data?.data });
            successCallback && successCallback(response);
          }
        } catch (error) {
        } finally {
          useLoadingStore.getState().setLoading(false);
        }
      },

      getSkillCheckListRequirements: async (successCallback) => {
        useLoadingStore.getState().setLoading(true);
        const { positionId } = get();
        try {
          const { data: response } = await makeRequest(
            HTTP.GET,
            API_ENDPOINTS.GET_SKILLCHECKLIST_REQUIREMENTS,
            null,
            null,
            positionId
          );
          if (response.success) {
            set({ documentStep: response?.data?.data });
            successCallback && successCallback(response);
          }
        } catch (error) {
        } finally {
          useLoadingStore.getState().setLoading(false);
        }
      },

      deleteOnboarding: async ({ id, successCallback }) => {
        set({ onboardingLoading: true });
        useLoadingStore.getState().setLoading(true);
        try {
          const { data: response } = await makeRequest(
            HTTP.DELETE,
            API_ENDPOINTS.DELETE_ONBOARDING,
            null,
            null,
            id
          );

          if (response.success) {
            successCallback && successCallback(response);
            await get().getAllOnboarding();
            get().resetPagination();
          }
        } catch (error) {
        } finally {
          set({ onboardingLoading: false });
          useLoadingStore.getState().setLoading(false);
        }
      },

      statusChangeOnboarding: async ({ id, status, successCallback }) => {
        useLoadingStore.getState().setLoading(true);
        set({ onboardingLoading: true });
        try {
          const { data: response } = await makeRequest(
            HTTP.PUT,
            API_ENDPOINTS.STATUS_CHANGE_ONBOARDING,
            status,
            null,
            id
          );

          if (response.success) {
            successCallback && successCallback(response);
          }
        } catch (error) {
        } finally {
          set({ onboardingLoading: false });
          useLoadingStore.getState().setLoading(false);
        }
      },
    }),

    {
      name: 'onboarding-store',
      partialize: (state) => ({
        selectedSteps: state.selectedSteps,
        walkTroughId: state.walkTroughId,
        walkThroughAbbreviation: state.walkThroughAbbreviation,
        walkThroughName: state.walkThroughName,
        positionId: state.positionId,
        onboardingStepStored: state.onboardingStepStored,
        activeStep: state.activeStep,
      }),
    }
  )
);

export default useOnboardingStore;
